import React from 'react';
import { CodeListHolder } from './types';
import { ResizableTable } from '../../common/resizable-table';

import styles from './code-description-table.scss';

export const CodeDescriptionTable: CodeListHolder = ({
  translation, children
}) => {

  return <ResizableTable>
    <thead>
      <tr>
        <th className={styles.colId}>{translation.code}</th>
        <th className={styles.colCodetable}>{translation.codetable}</th>
        <th className={styles.colLanguage}>{translation.language}</th>
        <th className={styles.colName}>{translation.description}</th>
        <th className={styles.colName}>{translation.long_description}</th>
      </tr>
    </thead>
    <tbody>
      {children}
    </tbody>
  </ResizableTable>;
};
